import { useQuery, useQueryClient } from '@tanstack/react-query'
import { EmptyState } from '@cinesend/ui-kit'
import FieldValue from '../field_value'
import QueryState from '../query_state'

const FieldsByLanguage = ({ assetID, languageID, cycleID }) => {
  const queryClient = useQueryClient()
  const queryKey = [`field-values`, `?assetID=${assetID}`, `&languageID=${languageID}`, `&cycleID=${cycleID}`]
  const {
    data: fields,
    isInitialLoading,
    isError,
    error,
  } = useQuery({
    queryKey,
    enabled: Boolean(assetID && languageID && cycleID),
  })
  const refreshValues = () => queryClient.invalidateQueries(queryKey)

  return (
    <QueryState isLoading={isInitialLoading} error={isError ? error : null}>
      {!fields?.length ? (
        <EmptyState title='No localized fields' detail='This asset type has no localizable metadata fields.' />
      ) : (
        <div className='grid gap-4 sm:grid-cols-2'>
          {fields.map((field) => (
            <div key={field.id} id={`field-${field.name?.toLowerCase()?.replaceAll(' ', '-')}`}>
              <FieldValue
                cacheKey={queryKey}
                field={field}
                assetID={assetID}
                cycleID={cycleID}
                languageID={languageID}
                refreshValues={refreshValues}
              />
            </div>
          ))}
        </div>
      )}
    </QueryState>
  )
}

export default FieldsByLanguage
